import { formatDateWithTime, getLocalISO } from "lib/utils/date-utils";
import { useState } from "react";

interface LoggingState {
  lastLogItem: LogItem;
  logItems: LogItem[];
  write2Log: (content: string, link?: string) => void;
}

const useLogging = (initialItem?: LogItem): LoggingState => {
  const [logItems, setLogItems] = useState<LogItem[]>([initialItem]);

  const write2Log = (content: string, link?: string) => {
    const timestamp = formatDateWithTime(getLocalISO(new Date()));
    const newLogItem: LogItem = {
      timestamp: timestamp,
      content: content,
      link: link,
    };
    setLogItems((prevItems) => [...prevItems, newLogItem]);
  };

  return {
    logItems,
    lastLogItem: logItems[logItems.length - 1] || initialItem,
    write2Log,
  };
};

export default useLogging;
